export default function ConsentCheckboxLabel({
  htmlFor,
  items,
  onConsentClick,
}) {
  return (
    <label
      htmlFor={htmlFor}
      className="ml-2 text-sm select-none flex items-center"
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
    >
      <span>
        {items.map((item, idx) =>
          item.clickable ? (
            <span
              key={idx}
              className="text-red-600 underline cursor-pointer"
              onClick={() => onConsentClick(item.type)}
            >
              {item.text}
            </span>
          ) : (
            <span key={idx}>{item.text}</span>
          )
        )}
      </span>
    </label>
  );
}
